import React, {ReactElement} from 'react';
import {styled} from 'styled-components';

/**
 * 체크박스 컴포넌트의 Props 인터페이스
 * @property {ReactElement} [children] - 자식 요소
 * @property {boolean} checked - 선택 여부
 * @property {() => void} [onChange] - 변경 이벤트 핸들러
 * @property {React.CSSProperties} [style] - 스타일
 * @property {string} [checkOnImg] - 체크 온 이미지 경로
 * @property {string} [checkOffImg] - 체크 오프 이미지 경로
 * @property {() => void} [onClickWrap] - 래퍼 클릭 핸들러
 * @property {string} [image] - 이미지 경로
 * @property {React.CSSProperties} [checkboxStyle] - 체크박스 스타일
 */
interface ICheckBox {
  children?: ReactElement;
  checked: boolean;
  onChange?: () => void;
  style?: React.CSSProperties;
  checkOnImg?: string;
  checkOffImg?: string;
  onClickWrap?: () => void;
  image?: string;
  checkboxStyle?: React.CSSProperties;
}

/**
 * 체크박스 컴포넌트
 * 체크박스를 표시하는 컴포넌트입니다.
 * @param {ICheckBox} props - 체크박스 컴포넌트의 props
 * @returns {JSX.Element} 체크박스 컴포넌트
 */
const CheckBox = ({
  children,
  checked,
  onChange,
  style,
  checkOnImg,
  checkOffImg,
  onClickWrap,
  image,
  checkboxStyle,
}: ICheckBox) => {
  return (
    <Container style={style} onClick={onClickWrap}>
      <Checkbox
        src={
          image
            ? image
            : checked
            ? checkOnImg
              ? checkOnImg
              : 'images/login/check_on.png'
            : checkOffImg
            ? checkOffImg
            : 'images/login/check_off.png'
        }
        alt="check"
        style={checkboxStyle}
      />
      {!onClickWrap && (
        <input type="checkbox" onChange={onChange} style={{display: 'none'}} />
      )}
      {children}
    </Container>
  );
};

const Container = styled.label`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  cursor: pointer;
`;

const Checkbox = styled.img`
  width: max(15px, min(1.6vw, 30px));
  height: max(15px, min(1.6vw, 30px));
`;

export default CheckBox;
